import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Candidate from "../../layouts/Candidate";
import axios from "../../services/axios";

function Instruction() {
  //const [ids, setIds] = useState("")
  const [name, setName] = useState("");
  const [status, setStatus] = useState(false);
  const { id, candidateId } = useParams(); // candidateId

  useEffect(() => {
    localStorage.setItem("ids", candidateId);
  }, []);

  const handleSubmit = () => {
    window.location.replace(`/subjectiveQuestion/${id}`);
  };

  useEffect(() => {
    {
      candidateId &&
        axios
          .get(`/candidates/${candidateId}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          })
          .then((res) => {
            const resp = res.data;
            if (
              resp.questionAnswerId &&
              (resp.questionAnswerId.avgScore ||
                resp.questionAnswerId.avgScore === 0)
            ) {
              setStatus(false);
            } else {
              setStatus(true);
            }
            const data = res.data.name;
            setName(data);
          });
    }
  }, [id]);

  return (
    <Candidate>
      {status ? (
        <section>
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h1 className="mainHeadingone text-darkblue">
                Hi ({name}), let's get started with the communication test.
              </h1>
              <p className="text-center mainHeadingCaption mt-2">
                Maxicus empowers YOU - our employees—to grow beyond your
                potential. We offer the perfect opportunities for personal,
                professional, and financial success.
              </p>
            </div>
          </div>

          <div className="row my-3 justify-content-center">
            <div className="col-md-8">
              <div className="card shadow w-100 border-0">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <img
                        src="https://img.freepik.com/free-vector/female-student-listening-webinar-online_74855-6461.jpg?t=st=1649142434~exp=1649143034~hmac=f36a58e8c613c227895276897b250a4eb5c5de51617bba94f0ec2ba484dad9ba&w=826"
                        className="w-100"
                      />
                    </div>
                    <div className="col-md-8 pl-4">
                      <div>
                        <ul>
                          <li>
                            Test will be auto-submitted once the time limit is
                            over, so please adhere
                          </li>
                          <li>You are not allowed to toggle the tabs </li>
                          <li>
                            Please do not close the window until the test is
                            done{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-3 justify-content-center">
            <div className="col-md-8 ">
              <div className="card shadow w-100 border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-cce">
                          <thead>
                            <tr>
                              <th scope="col">Categories</th>
                              <th scope="col">Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Word count </td>
                              <td style={{ color: "red" }}>
                                {" "}
                                The minimum word limit in a paragraph is 50
                              </td>
                            </tr>

                            <tr>
                              <td>Special keyword</td>
                              <td>
                                Candidates are suggested to use the keywords
                                from the list given
                              </td>
                            </tr>

                            <tr>
                              <td>Spell check </td>
                              <td>
                                There will be negative marking on each incorrect
                                spelling{" "}
                              </td>
                            </tr>

                            <tr>
                              <td>Grammar </td>
                              <td>
                                There will be negative marking on each
                                grammatically incorrect sentence
                              </td>
                            </tr>
                            <tr>
                              <td>Vocabulary</td>
                              <td>
                                Candidates are suggested to use different words
                                in every sentence
                              </td>
                            </tr>

                            <tr>
                              <td>Sentence count</td>
                              <td>
                                There should be a minimum of 6 lines in an
                                entire paragraph
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        onClick={handleSubmit}
                        className="btn btn-primary ml-auto d-block border-0"
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        Start Test
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="row justify-content-center mt-5">
          <h1>You have already attempted the test.</h1>
        </div>
      )}
    </Candidate>
  );
}

export default Instruction;
